import React from 'react';
import Collections from '@/components/Collections/Collections';
import ContentPane from '@/components/ContentPane/ContentPane';
import WithStandardLayout from '@/layouts/withStandard.layout';
import WithReferralLayout from '@/layouts/withReferral.layout';
import initializeIconLibrary from '@/utils/fontAwesomeLibrary';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useRouter } from 'next/router';
import useReAuth from '@/hooks/useReAuth';
import { buildServerSidePropsWithReqParams } from '@/utils/server';

initializeIconLibrary();

const CollectionsPage = ({ query }) => {
  const router = useRouter();
  useReAuth();
  return (
    <ContentPane>
      <Collections urlQueryParameters={Object.assign({}, query, router.query)} isFullPage={true} />
    </ContentPane>
  );
};

export const getServerSideProps = buildServerSidePropsWithReqParams({ query: {} });

CollectionsPage.getLayout = function getLayout(page) {
  return (
    <WithStandardLayout host={page.props.host}>
      <WithReferralLayout>{page}</WithReferralLayout>
    </WithStandardLayout>
  );
};

export default CollectionsPage;
